import { PLATFORM } from "aurelia";

import { ICobrasAlarmData, IContactData, IEditUserTableData } from "@/interfaces";

export function wait<T>(milliseconds: number, data?: T) {
  return new Promise<T>((resolve) => {
    PLATFORM.taskQueue.queueTask(
      () => {
        resolve(data);
      },
      { delay: milliseconds }
    );
  });
}

export function waitError<T>(milliseconds: number, data: T) {
  return new Promise<T>((resolve, reject) => {
    PLATFORM.taskQueue.queueTask(
      () => {
        reject(data);
      },
      { delay: milliseconds }
    );
  });
}

export const listDataAsync = async () =>
  //@ts-expect-error extra props, will be gone in prod
  wait<IEditUserTableData[]>(2000, userData);

// export const userDataAsync = async () =>
//   wait<IUserSettingsData>(2000, {
//     email: "take_me_on@a-ha.no",
//     firstName: "Braut E.",
//     lastName: "Håland",
//     darkTheme: false,
//     company: "Marine Tech LLC",
//     emailNotifications: true,
//     mobileNotifications: false,
//     position: "FW",
//     units: EUnit.Imperial,
//     username: "fairytalee",
//   });

export const cobrasAlarmsAsync = async () =>
  wait<ICobrasAlarmData[]>(2000, [
    {
      id: "fdgdfg",
      tagName: "Engine Press",
      value: 7,
    },
    {
      id: "adsgfdgadasdsa",
      tagName: "Fuel Diesel",
      value: 3,
    },
    {
      id: "fds",
      tagName: "Gen Load 1",
      value: 0,
    },
    {
      id: "fasfsafdsagasf",
      tagName: "Gen Load 2",
      value: 10,
    },
    {
      id: "adsadfdsffdsfsfsasdsa",
      tagName: "Tonnage Counter",
      value: 4,
    },
  ]);

export const contactDataAsync = async (searchText: string) =>
  wait<IContactData[]>(
    2000,
    contactData.filter(
      (contact) =>
        contact.firstName.toLocaleLowerCase().startsWith(searchText) ||
        contact.lastName.toLocaleLowerCase().startsWith(searchText) ||
        `${contact.firstName} ${contact.lastName}`.toLocaleLowerCase().startsWith(searchText) ||
        contact.email.toLocaleLowerCase().startsWith(searchText)
    )
  );

export const editUserDataAsync = async (id: string) => {
  const user = userData.find((user) => user.id === id);

  if (user) return wait(2000, user);
  else return waitError(2000, user);
};

// export const pbReportsDataAsync = async () => {
//   const mockData: IReportRowData[] = [
//     {
//       status: EReportStatus.Closed,
//       priority: EReportPriority.Low,
//       vesselName: "BJ Blue Marlin",
//       vesselId: "123123a",
//       id: 123456,
//       description: "Lorem ipsum dolor sit amet 1",
//       createdAt: new Date("2023-06-01T09:00:00Z"),
//       dueAt: new Date("2023-08-10T09:00:00Z"),
//       planned: 5,
//       unplanned: 3,
//       group: "Group A",
//       subgroup: "Subgroup 1",
//       owner: "John Doe",
//     },
//     {
//       status: EReportStatus.Open,
//       priority: EReportPriority.High,
//       vesselName: "Avery Island",
//       vesselId: "123123b",
//       id: 234567,
//       description: "Lorem ipsum dolor sit amet 2",
//       createdAt: new Date("2023-06-02T09:00:00Z"),
//       dueAt: new Date("2023-07-11T09:00:00Z"),
//       planned: 7,
//       unplanned: 2,
//       group: "Group B",
//       subgroup: "Subgroup 2",
//       owner: "Jane Smith",
//     },
//     {
//       status: EReportStatus.OnHold,
//       priority: EReportPriority.High,
//       vesselName: "Deer Island",
//       vesselId: "123123c",
//       id: 987654,
//       description: "Lorem ipsum dolor sit amet 10",
//       createdAt: new Date("2023-06-10T09:00:00Z"),
//       dueAt: new Date("2023-06-25T09:00:00Z"),
//       planned: 3,
//       unplanned: 1,
//       group: "Group C",
//       subgroup: "Subgroup 3",
//       owner: "Michael Johnson",
//     },
//   ];
//   return wait(20, mockData);
// };

export const userData = [
  {
    firstName: "Frances",
    lastName: "Holmes",
    id: "638a594668074f657725a2e1",
    accessLevel: "Basic",
    position: "Boss",
    company: "Illumity",
    email: "francesholmes@illumity.com",
    username: "velit",
  },
  {
    firstName: "Ashley",
    lastName: "Hewitt",
    id: "638a594654f78147863fe301",
    accessLevel: "Basic",
    position: "CEO",
    company: "Melbacor",
    email: "ashleyhewitt@melbacor.com",
    username: "mollit",
  },
  {
    firstName: "Goodwin",
    lastName: "Hoover",
    id: "638a5946603dea240e3bf9b6",
    accessLevel: "Basic+",
    position: "Boss",
    company: "Twiggery",
    email: "goodwinhoover@twiggery.com",
    username: "consectetur",
  },
  {
    firstName: "Kirkland",
    lastName: "Manning",
    id: "638a594679542fccd72a4131",
    accessLevel: "Basic+",
    position: "CEO",
    company: "Octocore",
    email: "kirklandmanning@octocore.com",
    username: "enim",
  },
  {
    firstName: "Tyler",
    lastName: "Puckett",
    id: "638a5946872a850c81062481",
    accessLevel: "Basic",
    position: "Tech",
    company: "Handshake",
    email: "tylerpuckett@handshake.com",
    username: "in",
  },
  {
    firstName: "Julia",
    lastName: "Gordon",
    id: "638a5946a58cac2c644bc516",
    accessLevel: "Basic",
    position: "Tech",
    company: "Vendblend",
    email: "juliagordon@vendblend.com",
    username: "voluptate",
  },
  {
    firstName: "Katharine",
    lastName: "Welch",
    id: "638a5946a8ebfa629a6e7e5e",
    accessLevel: "Basic+",
    position: "Tech",
    company: "Dancity",
    email: "katharinewelch@dancity.com",
    username: "dolore",
  },
  {
    firstName: "Lara",
    lastName: "Bishop",
    id: "638a5946110659ce0af8a916",
    accessLevel: "Admin",
    position: "Boss",
    company: "Zentix",
    email: "larabishop@zentix.com",
    username: "excepteur",
  },
  {
    firstName: "Christian",
    lastName: "Wise",
    id: "638a594683c63b5dabd5c8e6",
    accessLevel: "Basic",
    position: "CEO",
    company: "Steelfab",
    email: "christianwise@steelfab.com",
    username: "dolore",
  },
  {
    firstName: "Weber",
    lastName: "Browning",
    id: "638a5946f1294d37a902dc2c",
    accessLevel: "Admin",
    position: "Tech",
    company: "Sustenza",
    email: "weberbrowning@sustenza.com",
    username: "excepteur",
  },
  {
    firstName: "Frankie",
    lastName: "Vaughn",
    id: "638a5946b9ecbb4595e6c8cf",
    accessLevel: "Admin",
    position: "Boss",
    company: "Cablam",
    email: "frankievaughn@cablam.com",
    username: "commodo",
  },
  {
    firstName: "Lavonne",
    lastName: "Mendoza",
    id: "638a594627f69a08f73be7c2",
    accessLevel: "Admin",
    position: "CEO",
    company: "Sunclipse",
    email: "lavonnemendoza@sunclipse.com",
    username: "aliquip",
  },
  {
    firstName: "Chasity",
    lastName: "Crawford",
    id: "638a5946feeeebeef141d4f0",
    accessLevel: "Basic+",
    position: "CEO",
    company: "Elentrix",
    email: "chasitycrawford@elentrix.com",
    username: "excepteur",
  },
  {
    firstName: "Jacobson",
    lastName: "Love",
    id: "638a594674ad01af23275362",
    accessLevel: "Basic",
    position: "Tech",
    company: "Futurize",
    email: "jacobsonlove@futurize.com",
    username: "sit",
  },
  {
    firstName: "Alisa",
    lastName: "Guerra",
    id: "638a5946dd8ddbca901c056e",
    accessLevel: "Basic+",
    position: "Tech",
    company: "Imperium",
    email: "alisaguerra@imperium.com",
    username: "occaecat",
  },
  {
    firstName: "Shields",
    lastName: "Fernandez",
    id: "638a59464a26800f63c25342",
    accessLevel: "Basic+",
    position: "Boss",
    company: "Zidox",
    email: "shieldsfernandez@zidox.com",
    username: "adipisicing",
  },
  {
    firstName: "Fran",
    lastName: "Nixon",
    id: "638a5946eb38b0b45222b571",
    accessLevel: "Admin",
    position: "CEO",
    company: "Bleendot",
    email: "frannixon@bleendot.com",
    username: "ex",
  },
  {
    firstName: "Holman",
    lastName: "Herring",
    id: "638a59467db3fdec9c82d9ec",
    accessLevel: "Basic+",
    position: "CEO",
    company: "Besto",
    email: "holmanherring@besto.com",
    username: "labore",
  },
  {
    firstName: "Myrna",
    lastName: "Anthony",
    id: "638a59464f3babe7249019a2",
    accessLevel: "Basic",
    position: "CEO",
    company: "Liquidoc",
    email: "myrnaanthony@liquidoc.com",
    username: "laborum",
  },
  {
    firstName: "Mendez",
    lastName: "Snyder",
    id: "638a5946ce51f0d913947784",
    accessLevel: "Basic+",
    position: "Boss",
    company: "Nimon",
    email: "mendezsnyder@nimon.com",
    username: "officia",
  },
  {
    firstName: "Hines",
    lastName: "Pace",
    id: "638a5946299ab50ef04eac28",
    accessLevel: "Admin",
    position: "Boss",
    company: "Anivet",
    email: "hinespace@anivet.com",
    username: "ipsum",
  },
  {
    firstName: "Hilda",
    lastName: "Wells",
    id: "638a59464337011e709f4194",
    accessLevel: "Basic+",
    position: "CEO",
    company: "Amril",
    email: "hildawells@amril.com",
    username: "ad",
  },
  {
    firstName: "Cox",
    lastName: "Landry",
    id: "638a5946551c1639603003d4",
    accessLevel: "Admin",
    position: "Boss",
    company: "Honotron",
    email: "coxlandry@honotron.com",
    username: "labore",
  },
  {
    firstName: "Claudia",
    lastName: "Solomon",
    id: "638a59468a590560a0cc463c",
    accessLevel: "Basic+",
    position: "Boss",
    company: "Glukgluk",
    email: "claudiasolomon@glukgluk.com",
    username: "dolore",
  },
  {
    firstName: "Corina",
    lastName: "Mooney",
    id: "638a59465088b4e56f6ff5c9",
    accessLevel: "Admin",
    position: "Tech",
    company: "Orbaxter",
    email: "corinamooney@orbaxter.com",
    username: "nulla",
  },
  {
    firstName: "Wanda",
    lastName: "Whitaker",
    id: "638a5946cb06d0ec22364993",
    accessLevel: "Admin",
    position: "Boss",
    company: "Katakana",
    email: "wandawhitaker@katakana.com",
    username: "irure",
  },
  {
    firstName: "Mcintyre",
    lastName: "Griffin",
    id: "638a59461930d032cc294a4c",
    accessLevel: "Basic+",
    position: "Tech",
    company: "Microluxe",
    email: "mcintyregriffin@microluxe.com",
    username: "aliquip",
  },
];

export const contactData = [
  {
    // id: "6387330b77f6980363a01dab",
    firstName: "Watson",
    lastName: "Ingram",
    email: "watsoningram@bleendot.com",
  },
  {
    // id: "6387330b796021974135b281",
    firstName: "Howell",
    lastName: "Ashley",
    email: "howellashley@bleendot.com",
  },
  {
    // id: "6387330ba5e2e897303081d6",
    firstName: "Vincent",
    lastName: "Vargas",
    email: "vincentvargas@bleendot.com",
  },
  {
    // id: "6387330b279e8fc376bf06fe",
    firstName: "Queen",
    lastName: "Rush",
    email: "queenrush@bleendot.com",
  },
  {
    // id: "6387330b65172842c6d4c2ae",
    firstName: "Atkinson",
    lastName: "Harding",
    email: "atkinsonharding@bleendot.com",
  },
  {
    // id: "6387330b5018c701046300e5",
    firstName: "Knight",
    lastName: "Chen",
    email: "knightchen@bleendot.com",
  },
  {
    // id: "6387330b1e6313f69661da81",
    firstName: "Chambers",
    lastName: "Mcgowan",
    email: "chambersmcgowan@bleendot.com",
  },
  {
    // id: "6387330b639179f53593f587",
    firstName: "Lidia",
    lastName: "Washington",
    email: "lidiawashington@bleendot.com",
  },
  {
    // id: "6387330b975f1663bdece19f",
    firstName: "Aurelia",
    lastName: "Rios",
    email: "aureliarios@bleendot.com",
  },
  {
    // id: "6387330b044f8f0fae2c34df",
    firstName: "Deana",
    lastName: "Craft",
    email: "deanacraft@bleendot.com",
  },
  {
    // id: "6387330bde3631b4d0ee1970",
    firstName: "Josephine",
    lastName: "Marquez",
    email: "josephinemarquez@bleendot.com",
  },
  {
    // id: "6387330b582e72511813d08f",
    firstName: "Larson",
    lastName: "Britt",
    email: "larsonbritt@bleendot.com",
  },
  {
    // id: "6387330b2bcd78ac8ed66a54",
    firstName: "Marietta",
    lastName: "Logan",
    email: "mariettalogan@bleendot.com",
  },
  {
    // id: "6387330be91263bbdfdea977",
    firstName: "Crane",
    lastName: "Salazar",
    email: "cranesalazar@bleendot.com",
  },
  {
    // id: "6387330bd2d61bfabc9a8ee0",
    firstName: "Maldonado",
    lastName: "Mcconnell",
    email: "maldonadomcconnell@bleendot.com",
  },
  {
    // id: "6387330bf3554259c641ed36",
    firstName: "Fanny",
    lastName: "Phillips",
    email: "fannyphillips@bleendot.com",
  },
  {
    // id: "6387330b537267cdae468b19",
    firstName: "Burton",
    lastName: "Case",
    email: "burtoncase@bleendot.com",
  },
  {
    // id: "6387330b9e6f46d31b792ce9",
    firstName: "Jeannette",
    lastName: "Wilder",
    email: "jeannettewilder@bleendot.com",
  },
  {
    // id: "6387330bd91bfae4eb7b72dc",
    firstName: "Natalie",
    lastName: "Leach",
    email: "natalieleach@bleendot.com",
  },
  {
    // id: "6387330b6d5e985b91b5e2c8",
    firstName: "Hardin",
    lastName: "Murphy",
    email: "hardinmurphy@bleendot.com",
  },
  {
    // id: "6387330b2856699d55d4a4ac",
    firstName: "Valerie",
    lastName: "Browning",
    email: "valeriebrowning@bleendot.com",
  },
  {
    // id: "6387330b74d28916af1e6ca9",
    firstName: "Rosalinda",
    lastName: "Bishop",
    email: "rosalindabishop@bleendot.com",
  },
  {
    // id: "6387330b6a1d2d10adc19941",
    firstName: "Ingrid",
    lastName: "Bartlett",
    email: "ingridbartlett@bleendot.com",
  },
];
